import { message, Table, TableProps, Image, Flex, Button, Tooltip } from "antd";
import { CopyOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import { CopyToClipboard } from 'react-copy-to-clipboard';

import "./index.less";
import { LogType } from "../../interface";
import { getUtcTime, numberDigits, toThousands, updateAddress } from "@/utils";
import { formatSmartNumber } from "@/utils/formatNumber";
import TransactionTag from "@/components/TransactionTag";
import { getChainsResource } from "@/utils/methods";
import { cdnUrl } from '@/utils/cdn';
import { isSuiCoinType } from "@/utils/suiMethods";

const { imgPathPrefix }: any = getChainsResource();

export default function Logs({ logs, handleClearLogs, tokenAInfo, tokenBInfo }: any) {
  const { t } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  function onCopy() {
    messageApi.success(t("tips.copy"));
  }

  const columns: TableProps<LogType>['columns'] = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      align: 'center',
      width: 60,
      render: (text, record, index) => <div className='custom-td'>{logs.length - index}</div>, // 行号从 1 开始
    },
    {
      title: t("batchSwap.time"),
      dataIndex: 'time',
      align: 'center',
      render: (text, record, index) => {
        return (
          <div className='custom-td'>
            <span>{getUtcTime(record.time)}</span>
          </div>
        );
      },
    },
    {
      title: t("batchSwap.walletAddress"),
      dataIndex: 'address',
      align: 'center',
      render: (text, record, index) => {
        return (
          <div className='custom-td'>
            <span style={{ marginRight: '5px' }}>{updateAddress(record.address)}</span>
            <CopyToClipboard text={`${record.address}`} onCopy={() => { onCopy() }}>
              {/* <button>
                <img src={cdnUrl("/img/slerf/table-copy.svg")} alt="" />
              </button> */}
              <CopyOutlined style={{ color: '#bababa' }} />
            </CopyToClipboard>
          </div>
        );
      },
    },
    {
      title: t("batchSwap.tradingBehavior"),
      dataIndex: 'mintInAmount',
      align: 'center',
      render: (text, record, index) => {
        if (record.status != 2) {
          return <div className='sol-balance trade-action'>0</div>
        }
        const { display, fullValue } = formatSmartNumber(record.mintInAmount);
        return (
          <div className='custom-td'>
            <Tooltip title={toThousands(numberDigits(record.mintInAmount, 4))} placement="top">
              <span className='num'>{display}&nbsp;</span>
            </Tooltip>
            <Image
              style={{ width: 14, height: 14, marginRight: 4, position: "relative", top: "-1px" }}
              preview={false}
              src={isSuiCoinType(tokenAInfo.coinType) ? cdnUrl("/img/chains/sui.svg") : tokenAInfo.iconUrl}
              fallback={cdnUrl(`${imgPathPrefix}default-logo.svg`)}
            />
            <span>{record.tokenASymbol}</span>
            <img className='log-arrow' src={cdnUrl("/img/slerf/log-arrow.svg")} alt="" />
            <Image
              style={{ width: 14, height: 14, marginRight: 4, position: "relative", top: "-1px" }}
              preview={false}
              src={isSuiCoinType(tokenBInfo.coinType) ? cdnUrl("/img/chains/sui.svg") : tokenBInfo.iconUrl}
              fallback={cdnUrl(`${imgPathPrefix}default-logo.svg`)}
            />
            <span>{record.tokenBSymbol}</span>
          </div>

        );
      },
    },
    {
      title: t("batchSwap.status"),
      dataIndex: 'status',
      align: 'center',
      render: (text, record, index) => (
        <div className="custom-td">{switchStatus(record)}</div>
      ),
    },
  ];

  function switchStatus(row: any) {
    if (Number(row.status) === 0) {
      return <TransactionTag status={"noStart"} txt={t("batchTransfer.notExecuted")} />;
    }
    if (Number(row.status) === 1) {
      return <TransactionTag status={"loading"} txt="" />;
    }
    if (Number(row.status) === 2) {
      return <TransactionTag status={"success"} txt={t("batchTransfer.success")} hash={row.tx} onCopy={() => { onCopy() }} />;
    }

    if (Number(row.status) === 3) {
      return <TransactionTag status={"fail"} txt={row.msg} hash={row.tx} onCopy={() => { onCopy() }} />;
    }
  }

  return (
    <>
      {contextHolder}
      <section className="logs">
        <div className="title">
          <h4>{t('batchSwap.TransactionLog')}</h4>
          {
            logs.length > 0 && <div className="clear" onClick={handleClearLogs}>{t("batchSwap.clearLogs")}</div>
          }
        </div>
        <div className='table'>
          {logs.length ? (
            <>
              <div className="line"></div>
              <Table columns={columns} dataSource={logs} scroll={{ y: 390, x: 976 }} virtual pagination={false} />
            </>
          ) : (
            <Flex vertical justify="center" align="center" className="empty">
              <img src={cdnUrl("/img/logs-empty.svg")} alt="" />
              <span>{t('batchSwap.noRecords')}</span>
            </Flex>
          )}
        </div>
      </section>
    </>
  )
}